import * as React from 'react';
import SanitizedHTML from 'react-sanitized-html';

interface SafeHtmlProps {
	html: React.ReactNode;
	extraAllowedTags?: string[];
	allowedAttributes?: object;
}

const ALLOWED_TAGS = [
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'p',
	'a',
	'ul',
	'ol',
	'nl',
	'li',
	'b',
	'i',
	'strong',
	'em',
	'strike',
	'code',
	'hr',
	'br',
	'div',
	'span',
	'small',
];

export default class SafeHtml extends React.Component<SafeHtmlProps> {
	public render() {
		const { html, extraAllowedTags, allowedAttributes } = this.props;

		if (extraAllowedTags && extraAllowedTags.length > 0) {
			extraAllowedTags.forEach(tag => {
				ALLOWED_TAGS.push(tag);
			});
		}

		return (
			<>
				<SanitizedHTML allowedTags={ALLOWED_TAGS} allowedAttributes={allowedAttributes} html={html} />
			</>
		);
	}
}
